import { render, staticRenderFns } from "./ServiceGridBillIcon.vue?vue&type=template&id=544311a8&scoped=true"
import script from "./ServiceGridBillIcon.vue?vue&type=script&lang=js"
export * from "./ServiceGridBillIcon.vue?vue&type=script&lang=js"
import style0 from "./ServiceGridBillIcon.vue?vue&type=style&index=0&id=544311a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "544311a8",
  null
  
)

export default component.exports